import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { useSelector } from 'react-redux';
import enums from 'utils/enums';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { user, isUserLogout } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname, search, hash } = location;
  const encodedRedirectUrl = encodeURIComponent(`${pathname}${search}${hash}`);
  const redirectUri = isUserLogout ? 'login' : `login?redirect=${encodedRedirectUrl}`;

  const adminRoutes = [
    '/admin',
    '/admin/employees',
  ];

  const superAdminRoutes = [
    '/dashboard/analytics',
    '/dashboard/reports'
  ];

  useEffect(() => {
    checkAccess();
  }, []);

  useEffect(() => {
    checkAccess();
  }, [user, pathname, navigate, redirectUri]);

  const checkAccess = () => {
    if (!user) {
      navigate(redirectUri, { replace: true });
    } else {
      const isUserOrManager = user.role === enums.userRole.User || user.role === enums.userRole.SiteManager;
      if (isUserOrManager && adminRoutes.includes(pathname)) {
        navigate('/maintenance/access-denied');
      }
      const isUser = user.role === enums.userRole.User;
      if (isUser && superAdminRoutes.includes(pathname)) {
        navigate('/maintenance/access-denied');
      }
    }
  }

  if (!user) return <></>;
  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
